<div class="edit-page-root-container employee-edit-root-container">
    <div class="page-content">
        <div class="page-header">
            <button mat-button class="nav-button" (click)="onBack()">
                <mat-icon>arrow_back</mat-icon>
            </button>
            <div class="title">Attendance Export</div>
            <div class="action-btn-container">
                <button mat-flat-button color="primary" class="btn-proceed" (click)="onProceed()">Proceed</button>
            </div>
        </div>
        <div class="page-details">
            <form class="edit-form">
                <div class="detail-section">
                    <div class="content-container">
                        <section tabindex="0" class="export-section">
                            <!-- Header Summary -->
                            <div class="summary-header">
                                <b>
                                    Payroll Group: {{ attendanceHeader?.payroll_group_code || proceedData?.data?.employee_attendance_export[0]?.payrollgroup_code }}
                                    &nbsp; Year: {{ attendanceHeader?.year || proceedData?.data?.year }}
                                    &nbsp; Week: {{ attendanceHeader?.weekNo || proceedData?.data?.weekNo }}
                                    ({{ attendanceHeader?.start_date || dateRange }} - {{ attendanceHeader?.end_date || dateRange }})
                                </b>
                            </div>

                            <!-- Export Table -->
                            <table #exportTable class="classic-table" *ngIf="groupedData.length">
                                <!-- Main Header -->
                                <tr>
                                    <td colspan="5" class="main-header">
                                        <b>Employees having attendance hours more than 5</b>
                                    </td>
                                </tr>
                                
                                <!-- Payroll Group and Year/Week Header -->
                                <tr>
                                    <td colspan="2" class="info-header">
                                        <b>Payroll Group : {{ proceedData?.data?.payroll_name || proceedData?.data?.employee_attendance_export[0]?.payroll_group_name }}</b>
                                    </td>
                                    <td colspan="3" class="info-header">
                                        <b>Year {{ attendanceHeader?.year || proceedData?.data?.year }} Week {{ attendanceHeader?.weekNo || proceedData?.data?.weekNo }}</b>
                                    </td>
                                </tr>
                                
                                <!-- Blank Row -->
                                <tr>
                                    <td colspan="5" class="blank-row"></td>
                                </tr>
                                
                                <!-- Column Headers -->
                                <tr class="col-header">
                                    <td><b>Employee Name</b></td>
                                    <td><b>IN</b></td>
                                    <td><b>OUT</b></td>
                                    <td class="center-align"><b>Actual Worked Hours</b></td>
                                    <td class="center-align">
                                        <b>Include</b>
                                        <mat-checkbox
                                           
                                            [indeterminate]="isIndeterminate()"
                                            (change)="toggleSelectAll($event)">
                                        </mat-checkbox>
                                    </td>
                                </tr>

                                <!-- Data Rows -->
                                <ng-container *ngFor="let shop of groupedData; let shopIdx = index">
                                    <!-- Shop Name Row -->
                                    <tr class="shop-row">
                                        <td colspan="5"><b>{{ shop.shopName }}</b></td>
                                    </tr>
                                    
                                    <!-- Employee Records -->
                                    <tr *ngFor="let record of shop.records; let recIdx = index" class="data-row">
                                        <td>{{ getRowNumber(shopIdx, recIdx) }} {{ getEmployeeName(record) }}</td>
                                        <td>{{ record.shift_start_date }} {{ formatTime(record.shift_start_time) }}</td>
                                        <td>{{ record.shift_end_date }} {{ formatTime(record.shift_end_time) }}</td>
                                        <td align="right">{{ record.actual_work_hours }}</td>
                                        <td align="center">
                                            <mat-checkbox
                                                [checked]="isIncluded(record)"
                                                (change)="onIncludeChange(record, $event)"
                                                [attr.data-id]="record.temp_export_id"
                                                class="isInclude"
                                            ></mat-checkbox>
                                        </td>
                                    </tr>
                                </ng-container>
                            </table>
                        </section>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
